export default __webpack_public_path__ + "static/media/main-bar-group@2x.1122c7d8.png";